import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import CoreMap from '@bd/bdui-coremap';
import { Sticky } from '@bd/bdcore-utilities';

import CommunityCard from '../../components/CommunityCard';
import CommunityMapCard from '../../components/CommunityMapCard';
import icons from '../../components/IconsList';
import { colors } from '../../styles';

const communitiesMap = css`
  background-color: ${colors.color3};
  position: relative;
  height: calc(100vh - 115px);
  max-height: 1027px;
  width: 100%;
  z-index: 0;
  @media (min-width: 992px) {
    width: auto;
    flex-grow: 1;
  }
  .leaflet-popup-content {
    width: 80vw !important;
    margin: 0;
    @media(min-width: 550px) {
      width: 476px !important;
    }
  }
  .leaflet-container {
    width: 100%;
    height: 100%;
  }
  .leaflet-popup-content-wrapper {
    border-radius: 0;
    padding: 15px;
    .CommunityCard_wrapper {
      width: 100% !important;
    }
    .CommunityCard_inner {
      flex-direction: column !important;
    }
    .CommunityCard_mapButton {
      display: none !important;
    }
    .CommunityCard_detailButton {
      width: 100% !important;
    }
    .CommunityCard_buttonWrapper {
      margin: 0 !important;
    }
    .CommunityCard_priceValue {
      padding: 10px 8px !important;
    }
  }
`;

const styles = css`
  display: flex;
  .CommunitiesResults_list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 20px;
    background-color: #FFFFFF;
    @media(min-width: 992px) {
      flex-wrap: nowrap;
      padding: 0px;
      flex-direction: column;
      justify-content: flex-start;
      width: 590px;
      height: calc(100vh - 115px);
      max-height: 1027px;
      overflow-y: scroll;
      margin-top: 0;
    }
    @media(min-width: 1300px) {
      width: 646px;
    }
  }
  .CommunitiesResults_map {
    width: 100%;
    position: absolute;
    height: calc(100vh);
    right: 0;
    float: right;
    z-index: -4;
    @media(min-width: 992px) {
      flex: 1;
      z-index: 1;
      width: 55%;
      position: relative;
      height: 100%;
    }
    @media(min-width: 1200px) {
      width: 65%;
    }
  }
  .CommunitiesResults_mapAlt {
    position: relative;
    right: 0;
    height: auto;
    margin-bottom: 20px;
  }

  .leaflet-container {
    width: 100%;
    height: 100%;
  }
  .contact-modal.siteplan-modal {
  left: 15vw;
  right: 15vw;
  top: 5vh;
  .contact-modal-header {
    background-size: 100% auto;
  }
  .platmap-wrapper{
    height: 75vh;
  }
  .map-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1;
  }
  .leaflet-container {
    height: 75vh;
  }

  @media (max-width: 767px) {
    .contact-modal-body {
      padding: 5px 0;
    }
    .platmap-wrapper{
      height: 82vh;
    }
  }
  .plat-map-key {
    background-color: #FFF;
    position: absolute;
    z-index: 10;
    padding: 10px 0;
    top: 0;
    right: 15px;
    li {
      display: inline-block;
      padding: 0 10px;
    }
  }
  }
  .communitiesList {
    width:100%;
    .map-wrapper {
      width: 100%;
      height: 100%;
      z-index: 1;
      position: relative;
    }
    .map-key {
      position: absolute;
      z-index: 1000;
      background-color: white;
      bottom: 0;
      right: 80px;
      background: #FFFFFF;
      box-shadow: 0 0 20px 0 rgba(0,0,0,0.20);
      max-width: 50%;
      ul {
        text-align: center;
        li {
          display: inline-block;
          font-size: 13px;
          font-weight: 700;
          text-transform: uppercase;
          padding: 10px 10px;
          img {
            height: 16px;
            width: auto;
            margin: 0 6px 0 0;
          }
        }
      }
    @media (min-width: 2000px) {
      height: 1000px;
    }
  }
    .CardsList {
      width: 100%;
      padding: 15px 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      flex-wrap: wrap;
      background-color: white;
      z-index: 1;
      position: relative;
      @media (min-width: 992px) {
        min-height: calc(100vh + 100px);
        background-color: white;
        padding: 30px 0px;
        box-shadow: inset -13px 0px 19px -25px rgba(0,0,0,0.52);
        li{
          margin-bottom: 25px;
        }
      }
      @media (min-width: 992px) {
        width: 45%;
        height: 1000px;
        overflow-y: scroll;
        min-height: auto;
      }
      @media (min-width: 1200px) {
        width: 35%;
      }
      @media (min-width: 2000px) {
        height: 1000px;
        overflow-y: scroll;
      }
      li{
        @media(min-width: 992px) {
          margin-bottom: 15px;
          width: 50%;
        }
      }
    }
  }
  .communitiesCard {
    width: 350px;
    border: 0;
    border-top: 7px solid #FFFFFF;
    border-radius: 0;
    margin: 0 10px 15px 10px;
    a {
      color: #4B4B4B;
    }
    .card-media {
      background-color: #F2F2F2;
      background-image: url('/images/call-out-section-bg.jpg');
      background-size: cover;
      background-position: center center;
      position: relative;
      .noLogo {
        background-color: rgba(#B3CED0,.9);
        position: relative;
        &:after {
          content:"Image Coming Soon";
          font-weight: 800;
          color: #FFFFFF;
          display: block;
          text-align: center;
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 2px;
          position: absolute;
          top: 45%;
          width: 100%;
        }
      }
    }
    .card-content {
      padding: 15px;
      background-color: #F8F9F6;
      border: 0;
      .top-row {
        border-bottom: 1px solid #D7D9D2;
        margin: 0 0 10px 0;
      }
      h4 {
        color: #4B4B4B;
        font-size: 18px;
        text-transform: uppercase;
        font-weight: 800;
        letter-spacing: 2px;
        margin: 0 0 8px 0;
      }
      h5 {
        font-size: 13px;
        font-weight: 300;
        text-transform: uppercase;
        letter-spacing: 2px;
      }
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        li {
          font-family: SansSerif;
          a {
            color: ${colors.color5};
            // font-weight: 800;
          }
        }
      }
    }
  }
  .community-popup {
  .communitiesCard {
    width: 100%;
  }
  }
  .schools-list {
  margin: 0;
  padding: 0;
  list-style: none;
  li {
    margin: 0 0 10px 0;
    font-size: 14px;
    font-weight: 400;
    a {
      font-weight: 700;
    }
  }
  }
  .leaflet-popup-content {
  width: 210px !important;
  .communitiesCard {
    margin: 0;
  }
  .card-footer {
    display: none;
  }
  }
  .floor-plan-collections {
  width: 100%;
  text-align: center;
  }
.floor-plan-collections-mobile-btn {
    width: calc(100% - 30px);
    background-color: #B3CED0;
    height: 34px;
    line-height: 34px;
    font-weight: 700;
    font-family: $font-family-condensed;
    font-size: 16px;
    padding: 0 10px;
    margin-left: 15px;
    text-align: left;
    background-image: url('/images/icon-triangle-red.svg');
    background-position: 95% center;
    background-repeat: no-repeat;
    @media (min-width: 992px) {
      display: none;
    }
  }
  .CommunitiesResults_mapWrapper {
    @media(max-width: 991px) {
      position: relative !important;
      top: 0 !important;
    }
    @media(min-width: 0\0) {
      position: static !important;
    }
  }
  /* IE Styles */
  @media(min-width: 0\0) {
    .CommunitiesResults_map {
      height: 1000px;
    }
    .CommunitiesResults_map div:first-of-type {
      height: 100%;
      border: none;
    }
  }
`;

function CommunitiesResults({ communities, sort, viewMap }) {
  return (
    <div className={styles}>
      <div className="communitiesList">
        <div className="clearfix" />
        <Sticky style={{ top: '174px' }} className="CommunitiesResults_mapWrapper">
          <div className={`CommunitiesResults_map ${viewMap ? 'CommunitiesResults_mapAlt' : ''}`}>
            <CoreMap
              animate
              useFlyTo
              markers={communities}
              boundsOptions={{ animate: true, duration: 0.5 }}
              pin={{
                iconUrl: get(icons, 'mapPin'),
                iconSize: [26, 32],
                iconAnchor: [13, 32],
              }}
              className={communitiesMap}
              popup={({ marker: community }) => (
                <CommunityMapCard community={community} />
              )}
            />
          </div>
        </Sticky>
        <div className={`CardsList ${viewMap ? ' d-none d-lg-flex' : ''}`}>
          {
            orderBy(communities, sort.field, get(sort, 'dir', 'asc')).map(community => (
              <CommunityCard community={community} key={community._id} />
            ))
          }
        </div>
      </div>

    </div>
  );
}

CommunitiesResults.propTypes = {
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
  sort: PropTypes.object.isRequired,
  viewMap: PropTypes.bool,

};

CommunitiesResults.defaultProps = {
  viewMap: false,
};

export default withData(
  {
    communities: true,
  },
)(CommunitiesResults);



// WEBPACK FOOTER //
// ./src/pages/Communities/CommunityResults.js